import * as React from "react";
import Theme from "../../Theme";
type Props = {
    textColor?: string
    fillColor?: string
}
function Info({ textColor, fillColor }: Props) {
    return (
        <svg
            width={28}
            height={28}
            style={{minWidth: '28px'}}
            //@ts-ignore
            fill={textColor ? textColor : "none"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 0C6.272 0 0 6.272 0 14s6.272 14 14 14 14-6.272 14-14S21.728 0 14 0zm1.4 21h-2.8v-8.4h2.8V21zm0-11.2h-2.8V7h2.8v2.8z"
                //@ts-ignore
                fill={fillColor ? fillColor : Theme.colors.DarkGrey}
            />
        </svg>
    );
}

export default Info;